export function titleize(snakeCaseStr) {
    return snakeCaseStr
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export const parseQueryString = _ => {
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    
    const paramsObj = {};
    for (const [key, value] of searchParams) {
        paramsObj[key] = value;
    }
    
    return paramsObj
  }

export const abbreviateCommaNumber = (n) => {
  const num = parseInt(n, 10);
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(".0", "") + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(".0", "") + 'k';
  } else {
    return num.toString();
  }
}

export function copyToClipboard(str) {
  let el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export const formatUrl = (url) => {
  if (!url) return '#'; // Fallback for empty URLs
  // Check if the URL already has a protocol (http:// or https://)
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  // Prepend https:// to URLs without a protocol
  return `https://${url}`;
};
